<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-row type="flex" align="middle">
        <a-col :xs="2" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="sum_box">
            <!-- <div class="sum_box_title">总人数</div> -->
            <div class="sum_box_value">
              <div class="user_num">
                <a-statistic
                  title="总人数"
                  :value="count"
                  :valueStyle="{
                    color: '#011733',
                    fontSize: '32px',
                    fontWeight: '600',
                  }"
                  style="margin-right: 50px"
                  suffix="/人"
                >
                  <img
                    slot="prefix"
                    src="@/assets/image/user_icon.png"
                    alt=""
                  />
                </a-statistic>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :xs="2" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="sum_box">
            <div class="sum_box_value">
              <div class="user_num">
                <a-statistic
                  title="已培训"
                  :value="train_num"
                  :valueStyle="{
                    color: '#011733',
                    fontSize: '32px',
                    fontWeight: '600',
                  }"
                  style="margin-right: 50px"
                  suffix="/人"
                >
                  <img
                    slot="prefix"
                    src="@/assets/image/user_icon.png"
                    alt=""
                  />
                </a-statistic>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :xs="2" :sm="6" :md="6" :lg="6" :xl="3">
          <a-progress
            type="circle"
            :width="88"
            stroke-color="#0073FF"
            :percent="train_count_value"
            status="active"
            :strokeWidth="10"
          >
            <template #format="percent">
              <div style="color: #9ba2ab; font-size: 12px; margin-bottom: 10px">
                培训率
              </div>
              <span style="color: #011733; font-size: 14px"
                >{{ train_count_value }}%</span
              >
            </template>
          </a-progress>
        </a-col>
        <a-col :xs="2" :sm="6" :md="6" :lg="6" :xl="3">
          <a-progress
            type="circle"
            :width="88"
            stroke-color="#4DCC66"
            :percent="train_count_ok_value"
            status="active"
            :strokeWidth="10"
          >
            <template #format="percent">
              <div style="color: #9ba2ab; font-size: 12px; margin-bottom: 10px">
                合格率
              </div>
              <span style="color: #011733; font-size: 14px"
                >{{ train_count_ok_value }}%</span
              >
            </template>
          </a-progress>
        </a-col>
      </a-row>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="培训数据管理">
      <div slot="extra">
        <a-button
          icon="redo"
          @click="okedit"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          刷新数据
        </a-button>
      </div>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
        }"
      >
        <span
          slot="pass_type"
          slot-scope="text"
          :style="{ color: text == 1 ? '#EA1313' : '#4DCC66' }"
        >
          {{ text == 1 ? "不合格" : "合格" }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="editTrain(record)"
              style="color: #cacaca"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="printTestPaper(record)"
              v-permission="['train:trainData:printexam']"
              >打印试卷
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="printThree(record)"
              v-permission="['train:trainData:printeducation']"
              >打印三级教育卡</a-button
            >
          </a-space>
        </span>
      </a-table>
      <div style="margin-top: 20px; float: left">
        <a-button
          @click="exportHandle()"
          icon="download"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          导出
        </a-button>
        <a-button
          @click="printInfo(dataListSelections, ['1'])"
          icon="download"
          :loading="exportLoading"
          style="background: #edf5ff; border: none; color: #0073ff"
          v-permission="['train:trainData:printinfo']"
        >
          打印基本信息
        </a-button>
      </div>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <addorupdate ref="addorupdate" @ok="okedit"></addorupdate>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import { formatSeconds, docxContent } from "@/utils/util";
import { trainFile } from "@/utils/exportFile";
import { getSummary } from "@/request/classes";
import Saveprint from "@/utils/saveprint/index";
import addorupdate from "./components/editTraindata";
export default {
  mixins: [viewModule],
  components: { addorupdate },
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 80,
          align: "left",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "姓名",
          dataIndex: "person_name",
          key: "person_name",
          align: "left",
          width: 200,
        },
        {
          title: "分包单位",
          align: "left",
          key: "company_name",
          dataIndex: "company_name",
          width: 280,
        },
        // {
        //   title: "总培训课时",
        //   align: "left",
        //   key: "study_duration",
        //   dataIndex: "study_duration",
        //   width: 300,
        //   customRender: (text) => formatSeconds(text),
        // },
        {
          title: "总培训课时",
          align: "left",
          key: "class_number",
          dataIndex: "class_number",
          width: 200,
          // customRender: (text) => text ? text.split(',').length + '课时' : '0课时',
        },
        {
          title: "是否合格",
          align: "left",
          key: "pass_type",
          dataIndex: "pass_type",
          width: 200,
          scopedSlots: { customRender: "pass_type" },
        },
        {
          title: "分数",
          align: "left",
          key: "score",
          dataIndex: "score",
          width: 120,
        },
        {
          title: "培训时间",
          align: "left",
          key: "exam_time",
          dataIndex: "exam_time",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/train/page",
      },
      exportFileKey: trainFile,
      exportFileName: "培训数据导出文件",
      count: 0, //总人数
      train_num: 0, //培训人数
      train_count_value: 0, //培训率
      train_count_ok_value: 0, //培训合格率
      Save: null,
      exportLoading: false,
    };
  },
  methods: {
    formatSeconds,
    //编辑
    editTrain(e) {
      this.$refs.addorupdate.init(e);
    },
    //编辑完成
    okedit() {
      this.query();
      this.getInfo();
    },
    getInfo() {
      getSummary().then((res) => {
        console.log(res);
        this.count = res.data.count;
        this.train_num = res.data.train_num;
        this.train_count_value = res.data.train_count_value;
        this.train_count_ok_value = res.data.train_count_ok_value;
      });
    },
    //打印试卷
    async printTestPaper(record) {
      const result = JSON.parse(record.result); //试卷
      const officegen = require("officegen");
      const fs = require("fs");
      let docx = officegen("docx");
      docx.on("finalize", (written) => {
        console.log(written, "written");
      });
      docx.on("error", function (err) {
        console.log(err);
      });
      docxContent(record, docx, result);

      const { dialog } = require("electron").remote;

      // 在需要选择文件夹位置的地方调用这个函数
      try {
        // 通过 dialog.showOpenDialog() 打开文件夹选择对话框
        const result = await dialog.showOpenDialog({
          properties: ["openDirectory"], // 限制只能选择文件夹
          buttonLabel: "选择文件夹", // 自定义对话框按钮的文本
          title: "选择文件保存位置", // 对话框标题
        });
        if (result && result.length > 0) {
          const selectedFolder = result[0];
          console.log("Selected folder:", selectedFolder);
          // 在这里可以进一步处理选择的文件夹位置
          let out = fs.createWriteStream(
            selectedFolder + `\\${record.person_name}的试卷.docx`
          );
          out.on("error", (err) => {
            console.log(err);
            this.$notification["error"]({
              message: "保存失败",
              description: "此文件已存在并且被打开了，请关闭或删除旧文件",
            });
          });
          out.on("finish", () => {
            this.$notification["success"]({
              message: "保存成功",
              description: "试卷打印文件的docx已保存到指定位置",
            });
          });
          docx.generate(out);
        }
      } catch (err) {
        console.error("Error selecting folder:", err);
      }
    },
    //基本信息
    printInfo(dataListSelections, type) {
      console.log(dataListSelections);
      if (dataListSelections.length == 0)
        return this.$message.warning("至少勾选一条数据");
      if (!this.Save) {
        this.Save = new Saveprint();
        this.Save.setExportState((res) => {
          this.exportLoading = res.exportLoading; //是否在导出
          if (res.exportSuccess) {
            const key = `open${Date.now()}`;
            this.$notification["success"]({
              message: "档案导出成功",
              description: `已保存至: ${res.outputFolderPath}`,
              duration: 0,
              key: key,
            });
          }
        });
      }
      this.Save.fileInit(dataListSelections, type);
    },
    printThree(record) {
      this.printInfo([record], ["3"]);
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style scoped lang="scss">
.card_top_content {
  // display: flex;
  // flex-wrap: wrap;
  // align-items: center;
  // justify-content: space-between;
}
.sum_box {
  // border: 1px solid red;
  .sum_box_title {
    font-size: 18px;
    font-weight: 400;
    color: #9ba2ab;
  }

  .sum_box_value {
    display: flex;
    align-items: center;

    img {
      width: 32px;
      height: 32px;
    }

    .user_num {
      margin-left: 5px;
      font-size: 32px;
      font-family: Arial;
      font-weight: 400;
      color: #011733;
      img {
        margin-bottom: 5px;
      }
    }
  }
}
</style>